import Parceiro from "./Parceiro";
import Regra from "./Regra";

class Usuario {
  "id": Number = 0;
  "apelido": string = "";
  "nome": string = "";
  "email": string = "";
  "emailConfirmado": boolean = false;
  "passwordHash": string = "";
  "telefone": string = "";
  "dataBloqueio": Date = new Date();
  "bloqueado": boolean = false;
  "qtdeFalhasAcesso": Number;
  "criadoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
  "excluidoEm": Date = new Date();
  "regras": Regra[] | [];
  "parceiros": Parceiro[] | [];
}
export default Usuario;
